module.exports = __webpack_public_path__ + "static_pc/img/404.d47ad7e1.png";